import { render, staticRenderFns } from "./contractsTable.vue?vue&type=template&id=50416e67&scoped=true&"
import script from "./contractsTable.vue?vue&type=script&lang=js&"
export * from "./contractsTable.vue?vue&type=script&lang=js&"
import style0 from "./contractsTable.vue?vue&type=style&index=0&id=50416e67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50416e67",
  null
  
)

export default component.exports